/**
 * @copyright       Palace Resorts
 * @description     Mensajes para la sección de inicio.
 * @author          Roberto Pérez Guzmán
 * @creationDate    06 de Mayo del 2021
 */
export default {

    fallbackLocale: 'ESP',
    locale: 'ESP',
    messages: {
        'ESP': {
            'lblTitle': '¡Acceso no permitido!',
            'lblDescription': 'No cuenta con los privilegios para acceder al módulo solicitado. Por favor, verifique sus credenciales o ponganse en contacto con el Administrador del sistema.',
        },
        'ENG': {
            'lblTitle': 'Forbidden access!',
            'lblDescription': 'Access is not allowed to requested module. Please, check your credentials or contact to the System Administrator.',
        }
    }
}